/// <amd-module name="Work/Views/MyWork/DataProviders/IMyWorkProvider" />

import { IObservable } from "VSS/Core/Observable";
import { WorkItem } from "Wit/Clients/Wit/Contracts/WorkItemTracking";

export enum ProviderState {
    Uninitialized,
    Loading,
    Loaded,
    LoadedZeroData,
    Error
}

export interface IMyWorkProviderStateChangeArgs {
    provider: IMyWorkProvider;
    state: ProviderState;
    previousState: ProviderState;
}

export interface IMyWorkProvider extends IObservable<IMyWorkProviderStateChangeArgs> {

    /**
     * Start retrieving data.
     */
    initialize(): void;

    /**
     * Retrieves the current state of the data provider.
     */
    getState(): ProviderState;

    /**
     * Returns whether or not the limit of the number of work items has been exceeded.
     */
    getLimitExceeded(): boolean;

    /**
     * Returns the work items saved in the provider, or an empty array
     */
    getWorkItems(): WorkItem[];

    /**
     * Returns the number of work items currently saved in the provider
     */
    getWorkItemsCount(): number;
}

/**
 * Represents a formatted date value.  For date columns, the data provider may want to show a different date representation
 * for textual display, so 'date time' fields may return this object instead of a Date object.
 */
export interface FormattedDate {
    /**
     * Raw date object, unformatted
     */
    date: Date;
    /**
     * Textual representation of the date.
     */
    formattedDate: string;
}